<template>
  <div style="width: 100%; display: inline-block" class="draftcontract report">
    <!-- Bus Shelter -->
    <el-row>
      <el-col :span="24">
        <el-tabs v-model="TabAcitvity">
          <component
            :is="ContractDrafts.length === 2 ? ElTabPane : 'div'"
            :label="draft.action === 'media' ? 'Media' : 'Production'"
            v-for="(draft, index) in useContractDraft.ContractDrafts"
            :key="'pane' + index"
            :name="draft.action === 'media' ? 'Media' : 'Production'"
          >
            <div class="newRow">
              <!-- <div
                v-if="isUrgent()"
                style="
                  color: #e2202c;
                  font-weight: 700;
                  position: absolute;
                  top: 16px;
                  left: 150px;
                  font-size: 18px;
                  z-index: 99;
                "
              >
                Urgent
              </div> -->
              <div class="row" style="margin-bottom: 20px">
                <span
                  class="col-sm-4"
                  style="line-height: 32px; text-align: left; font-size: 18px"
                >
                  Draft Contract</span
                >
                <div
                  v-if="draft.isUrgent"
                  style="
                    color: red;
                    font-weight: 700;
                    position: absolute;
                    top: 16px;
                    left: 210px;
                    font-size: 36px;
                    z-index: 99;
                  "
                >
                  URGENT
                </div>
                <div class="col-sm-4" style="text-align: left">
                  <!-- <img
                    height="50"
                    v-if="draft.isUrgent"
                    width="260"
                    src="@/assets/img/urgent.png"
                  /> -->
                </div>
                <span
                  class="col-sm-4"
                  style="line-height: 32px; text-align: right; font-size: 18px"
                >
                  Contract No.(Draft): {{ draft.contractDraftNo }}</span
                >
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Company Entity Name</span
                >
                <span
                  class="col-sm-1"
                  style="
                    line-height: 32px;
                    text-align: left;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Contract No.</span
                >
                <span
                  class="col-sm-1"
                  style="
                    line-height: 32px;
                    text-align: right;
                    color: #754f34;
                    font-size: 12px;
                    padding: 0;
                  "
                  >{{ draft.contractNoProduct }}
                </span>
                <span
                  class="col-sm-2"
                  style="
                    line-height: 32px;
                    text-align: left;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Sub-Group Code</span
                >
                <span
                  class="col-sm-2"
                  style="
                    line-height: 32px;
                    text-align: left;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Date of Issue <span style="color: #b60005">*</span></span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-6"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <div style="display: flex; column-gap: 10px">
                    <base-input
                      style="flex-grow: 1"
                      disabled
                      v-model="draft.companyEntityCode"
                    >
                    </base-input>
                    <base-input
                      style="flex-grow: 23"
                      disabled
                      v-model="draft.companyName"
                    >
                    </base-input>
                  </div>
                </div>
                <div class="col-sm-2" style="padding-right: 0px">
                  <base-input disabled v-model="draft.contractNo"> </base-input>
                </div>
                <div class="col-sm-2" style="padding-right: 0px">
                  <base-input disabled v-model="draft.subgroupCode">
                  </base-input>
                </div>
                <div class="col-sm-2" style="padding-right: 0px">
                  <div class="custom-date-picker">
                    <base-input
                      :class="{
                        'has-error': validation.isError(
                          draft.validate,
                          'dateOfIssue'
                        ),
                      }"
                    >
                      <el-date-picker
                        :disabled="DraftContractPageStatus[index].disabled"
                        v-model="draft.dateOfIssue"
                        id="dateOfIssue"
                        type="date"
                        placeholder="Date Of Issue"
                        style="width: 100%; border: 0px"
                        format="DD/MM/YYYY"
                        value-format="YYYY-MM-DD"
                        :disabled-date="DisabledDate_DateOfIssue"
                        class="date"
                        @change="
                          ContractDrafts[index].signBackBeforeDate =
                            draft.dateOfIssue
                        "
                      >
                      </el-date-picker>
                    </base-input>
                  </div>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Company Address</span
                >
                <span
                  class="col-sm-2"
                  style="
                    line-height: 32px;
                    text-align: left;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Tel</span
                >
                <span
                  class="col-sm-2"
                  style="
                    line-height: 32px;
                    text-align: left;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Fax</span
                >
                <span
                  class="col-sm-2"
                  style="
                    line-height: 32px;
                    text-align: left;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Sign Back Before <span style="color: #b60005">*</span></span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-6"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input disabled v-model="draft.companyAddress">
                  </base-input>
                </div>
                <div class="col-sm-2" style="padding-right: 0px">
                  <div style="display: flex; column-gap: 10px">
                    <base-input
                      disabled
                      v-model="draft.companyTel"
                      style="flex-grow: 2"
                    >
                    </base-input>

                    <!-- <base-input disabled :modelValue="'-'" style="flex-grow: 8">
                    </base-input> -->
                  </div>
                </div>
                <div class="col-sm-2" style="padding-right: 0px">
                  <base-input disabled v-model="draft.companyFax"> </base-input>
                </div>

                <div class="col-sm-2" style="padding-right: 0px">
                  <div class="custom-date-picker">
                    <base-input
                      :class="{
                        'has-error': validation.isError(
                          draft.validate,
                          'signBackBeforeDate'
                        ),
                      }"
                    >
                      <el-date-picker
                        id="signBackBeforeDate"
                        :disabled="true"
                        v-model="draft.signBackBeforeDate"
                        type="date"
                        placeholder="Sign Back Date"
                        style="width: 100%; border: 0px"
                        format="DD/MM/YYYY"
                        value-format="YYYY-MM-DD"
                        class="date"
                      />
                    </base-input>
                  </div>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-12"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Contract Name</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-12"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input disabled v-model="draft.contractName">
                  </base-input>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-12"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Contracting Party</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-12"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input disabled v-model="draft.contractingParty">
                  </base-input>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-12"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Address</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-12"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input disabled v-model="draft.address"> </base-input>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-12"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Contact Person</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-12"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input disabled v-model="draft.contactPerson">
                  </base-input>
                </div>
              </div>
              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-12"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Email</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-12"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input disabled v-model="draft.contactPersonEmail">
                  </base-input>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Contact No. Tel</span
                >
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Contact No. Fax</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div class="col-sm-6" style="padding-left: 0px">
                  <base-input disabled v-model="draft.contactPersonTel">
                  </base-input>
                </div>
                <div
                  class="col-sm-6"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input disabled v-model="draft.contactPersonFax">
                  </base-input>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-12"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Advertiser</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-12"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input disabled v-model="draft.advertiser"> </base-input>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-12"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Product / Campaign</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-12"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input disabled v-model="draft.productName">
                  </base-input>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <div>
                  <span
                    style="
                      line-height: 32px;
                      text-align: left;
                      color: #754f34;
                      font-size: 12px;
                      margin-right: 15px;
                    "
                    >Media Item</span
                  >
                </div>
                <el-checkbox
                  label="Display Gross Rate Weekly"
                  :disabled="DraftContractPageStatus[index].disabled"
                  v-model="draft.showGrossRateWeekly"
                  v-if="useContract.getContractFunctionPermission('GrossRateWeekly')?.enable"
                ></el-checkbox>
                <el-checkbox
                  v-if="false"
                  label="Show Production Item Amount"
                  :disabled="DraftContractPageStatus[index].disabled"
                  v-model="draft.showProductionItemAmount"
                ></el-checkbox>
              </div>
              <div
                class="newCard"
                style="padding: 0px; margin: 0px; padding-top: 5px"
              >
                <el-table
                  :data="
                    ContractDraftMedias.filter(
                      (t) => t.contractDraftId === draft.id && !t.isBonus
                    )
                  "
                  :cell-style="{ verticalAlign: 'top' }"
                >
                  <el-table-column width="15">
                    <template slot-scope="scope"> </template>
                  </el-table-column>
                  <el-table-column
                    prop="mediaFormat"
                    label="Format"
                    width="330"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="location"
                    label="Description"
                    min-width="200"
                  >
                    <template #default="scope">
                      <div
                        style="word-break: break-word"
                        v-html="RawMediaDescriptionHTML(scope.row.id)"
                      ></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="grossRate"
                    label="Gross Rate"
                    min-width="170"
                    :formatter="formatterCellMoney"
                    v-if="useContract.ContractType == 'media'"
                  >
                    <template #header>
                      <div>
                        Gross Rate
                        {{
                          formatterMediaHeader(
                            ContractDraftMedias.filter(
                              (t) =>
                                t.contractDraftId === draft.id && !t.isBonus
                            )?.[0]?.unitRateOption
                          )
                        }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="unitCost"
                    label="Unit Cost"
                    min-width="170"
                    :formatter="formatterCellMoney"
                    v-else
                  >
                  </el-table-column>
                  <el-table-column
                    prop="quantity"
                    label="Qty/ Sec/hr"
                    min-width="170"
                  >
                    <template
                      #header
                      v-if="useContract.ContractType == 'production'"
                    >
                      <div>Qty</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="visualDates"
                    label="Visual Date"
                    v-if="useContract.ContractType == 'production'"
                  >
                    <template #default="scope">
                      <div
                        v-html="RawMediaVisualDateHTML(scope.row.visualDates)"
                      ></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="period"
                    label="Period"
                    min-width="170"
                    v-if="useContract.ContractType == 'media'"
                  >
                    <template #default="scope">
                      <span>{{ scope.row.period }}</span>
                      <span v-if="scope.row.isToBeConfirmed">{{
                        '\n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(To Be Confirmed)'
                      }}</span>
                    </template>
                  </el-table-column>

                  <!-- <el-table-column
                    prop="commencementDate"
                    label="Commencement Date"
                    min-width="150"
                  >
                    <template #default="scope">
                      <base-input
                        v-model="scope.row.commencementDate"
                        placeholder="Commencement Date"
                        style="width: 100%"
                        v-if="!DraftContractPageStatus[index].disabled"
                        :disabled="DraftContractPageStatus[index].disabled"
                      />
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    prop="duration"
                    label="Duration"
                    min-width="150"
                    v-if="useContract.ContractType == 'media'"
                  >
                  </el-table-column>
                </el-table>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-12"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Media Bonus Item</span
                >
              </div>
              <div
                class="newCard"
                style="padding: 0px; margin: 0px; padding-top: 5px"
              >
                <el-table
                  :data="
                    ContractDraftMedias.filter(
                      (t) => t.contractDraftId === draft.id && t.isBonus
                    )
                  "
                  class="bonus-media"
                  :cell-style="{ verticalAlign: 'top' }"
                >
                  <template #empty>
                    <div></div>
                  </template>

                  <el-table-column width="15">
                    <template slot-scope="scope"> </template>
                  </el-table-column>
                  <el-table-column
                    prop="mediaFormat"
                    label="Format"
                    width="330"
                    align="top"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="location"
                    label="Description"
                    min-width="200"
                  >
                    <template #default="scope">
                      <div
                        style="word-break: break-word"
                        v-html="RawMediaDescriptionHTML(scope.row.id)"
                      ></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="grossRate"
                    label="Gross Rate"
                    min-width="170"
                    :formatter="formatterCellMoney"
                    v-if="useContract.ContractType == 'media'"
                  >
                    <template #header>
                      <div>
                        Gross Rate
                        {{
                          formatterMediaHeader(
                            ContractDraftMedias.filter(
                              (t) =>
                                t.contractDraftId === draft.id && !t.isBonus
                            )?.[0]?.unitRateOption
                          )
                        }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="unitCost"
                    label="Unit Cost"
                    min-width="170"
                    :formatter="formatterCellMoney"
                    v-else
                  >
                  </el-table-column>
                  <el-table-column
                    prop="quantity"
                    label="Qty/ Sec/hr"
                    min-width="170"
                  >
                    <template
                      #header
                      v-if="useContract.ContractType == 'production'"
                    >
                      <div>Qty</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="visualDates"
                    label="Visual Date"
                    v-if="useContract.ContractType == 'production'"
                  >
                    <template #default="scope">
                      <div
                        v-html="RawMediaVisualDateHTML(scope.row.visualDates)"
                      ></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="period"
                    label="Period"
                    min-width="170"
                    v-if="useContract.ContractType == 'media'"
                  >
                    <template #default="scope">
                      <span>{{ scope.row.period }}</span>
                      <span v-if="scope.row.isToBeConfirmed">{{
                        '\n &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(To Be Confirmed)'
                      }}</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                    prop="commencementDate"
                    label="Commencement Date"
                    min-width="150"
                  >
                    <template #default="scope">
                      <base-input
                        v-if="!DraftContractPageStatus[index].disabled"
                        v-model="scope.row.commencementDate"
                        placeholder="Commencement Date"
                        style="width: 100%"
                        :disabled="DraftContractPageStatus[index].disabled"
                      />
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    prop="duration"
                    label="Duration"
                    min-width="150"
                    v-if="useContract.ContractType == 'media'"
                  >
                  </el-table-column>
                </el-table>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Grand Total</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div class="col-sm-6" style="padding-left: 0px">
                  <base-input
                    disabled
                    :modelValue="'HK' + formatter_money(draft.grandTotal)"
                  >
                  </base-input>
                </div>

                <el-checkbox
                  v-if="
                    draft.isWithoutSpecialDiscount && draft.action === 'media'
                  "
                  :disabled="
                    (draft.signed != 'Open') +
                      DraftContractPageStatus[index].disabled >
                    0
                  "
                  label="Without Special Discount"
                  name="type"
                  v-model="draft.withoutSpecialDiscount"
                />

                <el-checkbox
                  v-if="draft.bEnableDisplayHK"
                  :disabled="DraftContractPageStatus[index].disabled"
                  label="Display HK$"
                  name="type"
                  v-model="draft.displayHK"
                />
              </div>

              <div
                class="row"
                style="margin: 0px"
                v-if="draft.productionCost_Show"
              >
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Production Cost</span
                >
              </div>
              <div
                class="row"
                style="margin: 0px"
                v-if="draft.productionCost_Show"
              >
                <div class="col-sm-6" style="padding-left: 0px">
                  <base-input
                    disabled
                    :modelValue="'HK' + formatter_money(draft.productionCost)"
                  >
                  </base-input>
                </div>
                <div class="col-sm-6" style="padding-left: 0px">
                  <!-- <el-checkbox
                    :disabled="DraftContractPageStatus[index].disabled"
                    label="Show in Contract"
                    name="type"
                    v-if="draft.showinContract_Show"
                    v-model="draft.productionShowInContract"
                  /> -->
                </div>
              </div>

              <div
                class="row"
                style="margin: 0px"
                v-if="draft.nettGrandTotal_Show"
              >
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Nett Grand Total</span
                >
              </div>
              <div
                class="row"
                style="margin: 0px"
                v-if="draft.nettGrandTotal_Show"
              >
                <div class="col-sm-6" style="padding-left: 0px">
                  <base-input
                    disabled
                    :modelValue="'HK' + formatter_money(draft.nettGrandTotal)"
                  >
                  </base-input>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Payment Type</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div class="col-sm-6" style="padding-left: 0px">
                  <base-input
                    disabled
                    :modelValue="getPaymentTerm(draft.contractDraftNo)"
                  >
                  </base-input>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Payment Schedule</span
                >
              </div>
              <div
                class="row"
                style="
                  margin: 0px;
                  padding-bottom: 5px;
                  margin-bottom: 5px;
                  border-bottom: solid 1px #e3e3e3;
                "
              >
                <div class="col-sm-6" style="padding-left: 0px">
                  <!-- <el-checkbox
                    label="Show Total Amount only"
                    v-model="draft.paymentScheduleShowTotalAmountOnly"
                    :disabled="DraftContractPageStatus[index].disabled"
                  ></el-checkbox> -->
                </div>
              </div>
              <div
                class="newCard"
                style="padding: 0px; margin: 0px; padding-top: 5px"
              >
                <el-table :data="getPaymentSchedules(draft.contractDraftNo)">
                  <!-- <el-table-column type="No." label="No."  width="50"/> -->

                  <el-table-column width="15">
                    <template slot-scope="scope"> </template>
                  </el-table-column>
                  <el-table-column prop="psNo" label="PS NO." width="200">
                  </el-table-column>
                  <el-table-column
                    prop="description"
                    label="Description"
                    min-width="200"
                  >
                    <template #default="scope">
                      <span style="white-space: pre-wrap">{{
                        scope.row.description
                      }}</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                    prop="contractNo"
                    label="Contract No."
                    min-width="170"
                  /> -->
                  <el-table-column
                    prop="campaignPeriodStart"
                    :formatter="formatterCellDate"
                    label="From"
                    min-width="170"
                  />
                  <el-table-column
                    prop="campaignPeriodEnd"
                    :formatter="formatterCellDate"
                    label="To"
                    min-width="130"
                  />
                  <el-table-column
                    prop="noOfSchedule"
                    label="No. Of Schedule"
                    min-width="170"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="scheduleMediaAmount"
                    :formatter="formatterCellMoney"
                    label="Installment (Media)"
                    min-width="150"
                  />
                  <el-table-column
                    prop="scheduleProductionAmount"
                    :formatter="formatterCellMoney"
                    label="Installment (Production)"
                    min-width="150"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="totalScheduleAmount"
                    :formatter="formatterCellMoney"
                    label="Total Amount"
                    min-width="150"
                  >
                  </el-table-column>
                </el-table>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-6"
                  id="toInternalRemark"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Internal Remark</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-12"
                  style="padding-left: 5px; padding-right: 0px"
                >
                  <base-input>
                    <el-input
                      type="textarea"
                      :disabled="InternalRemarkDisabled(index)"
                      v-model="draft.internalRemark"
                      :autosize="{ minRows: 3 }"
                      class="textarea"
                    >
                    </el-input>
                  </base-input>
                </div>
              </div>
              <div
                class="row"
                style="margin: 0px"
                v-if="draft.isSpecialSchedule"
              >
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Approval Document
                </span>
              </div>
              <div
                class="row"
                v-if="draft.isSpecialSchedule"
                style="
                  margin: 0px;
                  padding-bottom: 5px;
                  margin-bottom: 5px;
                  border-bottom: solid 1px #e3e3e3;
                "
              >
                <div
                  class="newCard"
                  style="
                    padding-left: 0px;
                    text-align: center;
                    position: relative;
                  "
                >
                  <signcontractVue
                    :ContractDraftId="draft.id"
                    :FilePath="draft.approvalDocumentFile"
                    UploadType="ApprovalDocument"
                  />
                </div>
              </div>
              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Signed Contract</span
                >
              </div>
              <div
                class="row"
                style="
                  margin: 0px;
                  padding-bottom: 5px;
                  margin-bottom: 5px;
                  border-bottom: solid 1px #e3e3e3;
                "
              >
                <div
                  class="newCard"
                  style="
                    padding-left: 0px;
                    text-align: center;
                    position: relative;
                  "
                >
                  <signcontractVue
                    :ContractDraftId="draft.id"
                    :FilePath="draft.signedContractFile"
                    :OrderStatus="useContract.getOrderStatus()"
                    :Signed="useContract.getSingnedStatus()"
                  />
                </div>

                <div
                  style="
                    display: flex;
                    justify-content: flex-end;
                    margin-left: auto;
                    flex-direction: column;
                    margin-bottom: auto;
                  "
                >
                  <div
                    style="
                      justify-content: flex-end;
                      margin-left: auto;
                      margin-bottom: 20px;
                    "
                    v-if="
                      useAuthority.GetAuthority(
                        'SubFunction_CombinedContractRequired'
                      ) &&
                      draft.signed === 'Open' &&
                      draft.status !== 'Revised'
                    "
                  >
                    <!-- 修改 Combined Contract Required按钮-->
                    <el-link
                      style="margin-top: 10px"
                      :underline="false"
                      v-if="!draft.combinedContractRequired_Save"
                      @click="draft.combinedContractRequired_Save = true"
                    >
                      <svg-icon
                        style="width: 28px; height: 28px"
                        iconClass="edit"
                      />
                    </el-link>
                    <!-- 保存 Combined Contract Required按钮-->
                    <el-link
                      style="margin-top: 10px"
                      :underline="false"
                      v-if="draft.combinedContractRequired_Save"
                      @click="
                        useContractDraft.SaveCombinedContractRequired(draft);
                        draft.combinedContractRequired_Save = false;
                      "
                    >
                      <svg-icon
                        style="width: 28px; height: 28px"
                        iconClass="save"
                      />
                    </el-link>
                  </div>

                  <div style="">
                    <el-checkbox
                      :disabled="!draft.combinedContractRequired_Save"
                      label="Combined Invoice Required"
                      name="type"
                      v-model="draft.combinedContractRequired"
                    />
                  </div>
                </div>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                "
                v-if="
                  useAuthority.GetAuthority('SubFunction_EditBilling') &&
                  draft.signed === 'Open'
                "
              >
                <div></div>
                <div style="display: flex; column-gap: 5px">
                  <!-- 修改 BillingAddress按钮-->
                  <el-link
                    style="margin-top: 10px"
                    :underline="false"
                    :disabled="
                      useContract.getContractFunctionPermission('EditBilling')
                        .disable
                    "
                    v-if="!draft.clientAccountContact_Save"
                    @click="EditBilling(index)"
                  >
                    <svg-icon
                      style="width: 28px; height: 28px"
                      iconClass="edit"
                    />
                  </el-link>
                  <!-- 保存 BillingAddress按钮-->
                  <el-link
                    style="margin-top: 10px"
                    :underline="false"
                    v-if="draft.clientAccountContact_Save"
                    :disabled="
                      useContract.getContractFunctionPermission('EditBilling')
                        .disable
                    "
                    @click="
                      useContractDraft.SaveContractBillingAddress(draft);
                      draft.clientAccountContact_Save = false;
                    "
                  >
                    <svg-icon
                      style="width: 28px; height: 28px"
                      iconClass="save"
                    />
                  </el-link>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-12"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                >
                  Billing Address<span style="color: #d05c5f"> *</span></span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-12"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input style="background-color: #f5f5f5">
                    <el-select
                      class="select-primary"
                      v-model="draft.billingAddressId"
                      :disabled="!draft.clientAccountContact_Save"
                      @change="
                        useContractDraft.changeBillName(
                          index,
                          draft.billingAddressId
                        )
                      "
                      @focus="
                        useContractDraft.changeBillName(
                          index,
                          draft.billingAddressId
                        )
                      "
                    >
                      <el-option
                        class="select-primary"
                        v-for="(
                          item, index
                        ) in useContractDraft.BillNameOptionals"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                      />
                    </el-select>
                  </base-input>
                </div>
              </div>

              <!-- BillingAddress -->
              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-12"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Address</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-12"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input>
                    <el-input
                      disabled
                      type="textarea"
                      :rows="3"
                      v-model="draft.billingAddress"
                    >
                    </el-input>
                  </base-input>
                </div>
              </div>

              <!-- Invoice Remark -->
              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-12"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Invoice Remark</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div
                  class="col-sm-12"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input>
                    <el-input
                      :disabled="!draft.clientAccountContact_Save"
                      type="textarea"
                      :rows="3"
                      v-model="draft.invoiceRemark"
                    >
                    </el-input>
                  </base-input>
                </div>
              </div>

              <!-- Last Update by -->
              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-4"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Last Update by</span
                >
                <span
                  class="col-sm-4"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Last Update Date</span
                >
              </div>
              <div
                class="row"
                style="
                  margin: 0px;
                  padding-bottom: 10px;
                  margin-bottom: 15px;
                  border-bottom: solid 1px #e3e3e3;
                "
              >
                <div class="col-sm-4" style="padding-left: 0px">
                  <base-input disabled v-model="draft.billingUpdateByName">
                  </base-input>
                </div>
                <div class="col-sm-4" style="padding-left: 0px">
                  <base-input
                    disabled
                    :modelValue="formatter_datetime(draft.billingUpdateDate)"
                  >
                  </base-input>
                </div>
              </div>

              <!-- Sign Box -->
              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-6"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Sign Box</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <el-checkbox
                  :disabled="DraftContractPageStatus[index].disabled"
                  label="With Client Signature"
                  name="type"
                  v-model="draft.isSignature"
                />
              </div>

              <!-- Account Contact/Email/Contact Number -->
              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-4"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Account Contact</span
                >
                <span
                  class="col-sm-4"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Email</span
                >
                <span
                  class="col-sm-4"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Contact Number</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div class="col-sm-4" style="padding-left: 0px">
                  <base-input style="background-color: #f5f5f5">
                    <el-select
                      class="select-primary"
                      :disabled="DraftContractPageStatus[index].disabled"
                      v-model="draft.clientAccountContactNameEN"
                      @change="
                        ChangeClientAccountContact(
                          draft.clientAccountContactNameEN,
                          index
                        )
                      "
                    >
                      <el-option
                        class="select-primary"
                        v-for="(
                          item, index
                        ) in useContractDraft.clientAccountContacList"
                        :key="item.clientAccountContactNameEN"
                        :label="item.clientAccountContactNameEN"
                        :value="item.clientAccountContactNameEN"
                      />
                    </el-select>
                  </base-input>
                </div>
                <div class="col-sm-4" style="padding-left: 0px">
                  <base-input
                    disabled
                    v-model="draft.clientAccountContactEmail"
                  >
                  </base-input>
                </div>
                <div
                  class="col-sm-4"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input
                    disabled
                    v-model="draft.clientAccountContactNumber"
                  >
                  </base-input>
                </div>
              </div>

              <div class="row" style="margin: 0px">
                <span
                  class="col-sm-4"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Sign by</span
                >
                <span
                  class="col-sm-4"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Title</span
                >
                <span
                  class="col-sm-4"
                  style="
                    line-height: 32px;
                    text-align: left;
                    padding-left: 0px;
                    color: #754f34;
                    font-size: 12px;
                  "
                  >Salesperson</span
                >
              </div>
              <div class="row" style="margin: 0px">
                <div class="col-sm-4" style="padding-left: 0px">
                  <base-input style="background-color: #f5f5f5">
                    <el-select
                      class="select-primary"
                      :disabled="DraftContractPageStatus[index].disabled"
                      v-model="draft.signBy"
                      @change="changeSignByList(index)"
                    >
                      <el-option
                        class="select-primary"
                        v-for="(item, index) in SignByList"
                        :key="'signby' + index"
                        :label="item.signby_name"
                        :value="item.signby_code"
                      />
                    </el-select>
                  </base-input>
                </div>
                <div class="col-sm-4" style="padding-left: 0px">
                  <base-input disabled v-model="draft.signByTitle">
                  </base-input>
                </div>
                <div
                  class="col-sm-4"
                  style="padding-left: 0px; padding-right: 0px"
                >
                  <base-input disabled v-model="draft.salesPerson">
                  </base-input>
                </div>
              </div>

              <!-- <div
                style="
                  width: 100%;
                  display: flex;
                  justify-content: flex-end;
                  margin: 0px;
                "
              >
                <base-button type="primary">Edit</base-button>
              </div> -->

              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                "
              >
                <div style="column-gap: 5px; display: flex">
                  <base-button
                    @click="PDFDown(draft.draft_Id)"
                    class="btn-pdf"
                    :disabled="!DraftContractPageStatus[index].disabled"
                    >PDF</base-button
                  >

                  <base-button
                    @click="PDFDown(draft.draft_Id, true)"
                    class="btn-pdf"
                    :disabled="
                      !DraftContractPageStatus[index].disabled ||
                      useContract.getContractFunctionPermission('Preview')
                        ?.disable
                    "
                    v-if="useContract.isPreview"
                    >Preview</base-button
                  >
                </div>

                <div>
                  <base-button
                    style="background: #00bf9a"
                    class="btn-RegularSuccess"
                    v-if="isUnlock(index)"
                    @click="PageUnlockClick(index)"
                    :disabled="
                      PageUnlockInfo?.disable ||
                      useContract.getContractFunctionPermission('PageUnlock')
                        ?.disable
                    "
                    >Page Unlock</base-button
                  >
                  <base-button
                    style="background: #00bf9a"
                    class="btn-RegularSuccess"
                    v-if="isLock(index)"
                    :disabled="PageUnlockInfo?.disable"
                    @click="PageLockClick(index)"
                    >Page Lock</base-button
                  >
                </div>
                <div
                  style="display: flex; column-gap: 5px"
                  v-if="
                    useContract.getContractFunctionPermission('Edit')?.enable
                  "
                >
                  <base-button
                    type="primary"
                    v-if="DraftContractPageStatus[index].disabled"
                    @click="EditEvent(index)"
                    :disabled="
                      useContract.getContractFunctionPermission('Edit')?.disable
                    "
                    >Edit</base-button
                  >
                  <base-button type="primary" v-else @click="SaveEvent(index)"
                    >Save</base-button
                  >
                </div>
              </div>
            </div>
          </component>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import { nextTick, ref, reactive, onMounted, watch } from 'vue';
import {
  formatterCellMoney,
  formatterCellDate,
  formatter_money,
  formatter_date,
  formatter_datetime,
  formatterRate,
} from '@/assets/js/formatter';
import contractnet from '@/network/contractnet';
import { ElMessage, ElTabPane } from 'element-plus';
import signcontractVue from './signcontract.vue';
import dateJs from '@/assets/js/date';
import validation from '@/assets/js/validation';

import { useContractStore } from '@/store/contract';
import { useContractInfoStore } from '@/store/contractinfo';
import { useContractDraftStore } from '@/store/contractDraft';
import { useAuthorityStore } from '@/store/authority';
import { storeToRefs } from 'pinia';
import { useInternalSplitStore } from '@/store/internalsplit';

// Store
const useAuthority = useAuthorityStore();
const useContract = useContractStore();
const {
  // EnablePageUnlockMessage,
  // EnablePreviewMessage,
  Status,
  // EnableEditMessage,
  // bEnableEditBilling,
  // EnableEditBillingMessage,
} = storeToRefs(useContract);

const useContractDraft = useContractDraftStore();

const PageUnlockState = ref([]);
const DraftContractPageStatus = ref([]);
const bInit = ref(false);
const PageUnlockInfo = ref({});
const SignByList = ref([]);

const { ContractDrafts, ContractDraftPaymentDetails, ContractDraftMedias } =
  storeToRefs(useContractDraft);

const props = defineProps({
  isInit: {
    type: Boolean,
  },
});
// 更新是否保存当前Tab数据
const changeDraftUpdate = (ele, disabled, isLock) => {
  ele.isUpdate = !disabled || isLock;
};

// 初始化/重置PageUnlock状态
watch(
  () => ContractDrafts.value,
  (newVal) => {
    DraftContractPageStatus.value.splice(
      0,
      DraftContractPageStatus.value.length
    );

    SignByList.value = useContractDraft.getSignByList();

    newVal.forEach((element) => {
      UpdateEntity(element);
    });
  },
  {
    immediate: true,
  }
);

// 初始化/重置PageUnlock状态
watch(
  () => Status.value,
  (newVal) => {
    PageUnlockInfoChange();
  }
);

const UpdateEntity = (element) => {
  var disabled = (useContract.mode || 'view') === 'view';

  const PageTabActions = useContract.getPageTabActions();
  var isUnlock =
    useContract.getContractFunctionPermission('PageUnlock')?.enable;

  // if (EnableEditMessage.value) {
  //   disabled = true;
  // }
  if (useContract.getContractFunctionPermission('Edit')?.disable) {
    disabled = true;
  }

  var pageStatusEntity = {
    mode: useContract.mode,
    disabled,
    isUnlock,
    isLock: false,
  };

  DraftContractPageStatus.value.push(pageStatusEntity);

  changeDraftUpdate(element, disabled, pageStatusEntity.isLock);
};

// #region datas
const TabAcitvity = ref('Media');
// #endregion
// 初始化/重置PageUnlock状态
const PageUnlockInfoChange = () => {
  DraftContractPageStatus.value.splice(0, DraftContractPageStatus.value.length);

  ContractDrafts.value.forEach((element) => {
    UpdateEntity(element);
  });

  const PageTabActions = useContract.getPageTabActions();
  var PageUnlock_Action = PageTabActions?.find((t) => t.alias === 'PageUnlock');
  PageUnlockInfo.value.enable = PageUnlock_Action?.enable;
  PageUnlockInfo.value.disable = PageUnlock_Action?.disable;
  PageUnlockInfo.value.disableMessage = PageUnlock_Action?.disableMessage;
};

onMounted(async () => {
  PageUnlockInfoChange();
});

// Emits
const emits = defineEmits([
  'back',
  'next',
  'close',
  'edit',
  'save',
  'changeMode',
]);

const SaveEvent = async (index) => {
  // //保存 BillingAddress按钮是否激活
  // if (
  //   useContractDraft.ContractDrafts[index].clientAccountContact_Save == true
  // ) {
  //   ElMessage({
  //     message: 'Please complete previous steps first',
  //     type: 'warning',
  //   });
  //   return false;
  // }
  if (!await useInternalSplitStore().MinMaxDateInternalSplit()) {
    ElMessage({ message: 'Please double check the campaign period in internal split and payment schedule', type: 'warning' });
    return false;
  }
  if (!useContractDraftStore().MinMaxDatePaymentSchedule()) {
    ElMessage({ message: 'Please double check the campaign period in payment schedule', type: 'warning' });
    return false;
  }
  if (
    useContractDraft.ContractDrafts[index].combinedContractRequired_Save == true
  ) {
    ElMessage({
      message: 'Please complete previous steps first',
      type: 'warning',
    });
    return false;
  }
  var bSave = await SaveData(index).then((res) => res);
  if (!bSave) {
    return;
  }

  // 更新页面状态
  DraftContractPageStatus.value[index].mode = 'view';
  DraftContractPageStatus.value[index].disabled = true;
  useContract.changeMode(
    DraftContractPageStatus.value.find((t) => t.mode === 'edit')?.mode || 'view'
  );

  DraftContractPageStatus.value.forEach((element, a) => {
    const { disabled, isLock } = DraftContractPageStatus.value[a];
    changeDraftUpdate(ContractDrafts.value[a], disabled, isLock);
  });
};

//保存数据
const SaveData = async (index, Action) => {
  // 重置Update
  ContractDrafts.value.map((t) => (t.isUpdate = false));
  ContractDrafts.value[index].isUpdate = true;

  const message = await useContractDraft.SaveData(Action).then((res) => res);
  if (message !== '') {
    ElMessage({
      message,
      type: 'warning',
    });
    return false;
  }
  //EditIndex.value = -1;

  ElMessage({
    message: 'Save success',
    type: 'success',
  });
  // useContract.mode = 'view';

  //更新数据
  useContract.Init('DraftContract');

  return true;
};
// #region nextbar event
const EditEvent = (index) => {
  var message =
    useContract.getContractFunctionPermission('Edit').disableMessage;
  // if (EnableEditMessage.value) {
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }
  emits('changeMode', 'edit');
  DraftContractPageStatus.value[index].mode = 'edit';
  DraftContractPageStatus.value[index].disabled = false;

  changeDraftUpdate(ContractDrafts.value[index], false, false);
};

// PDF下载
const PDFDown = async (draftId, isPreview) => {
  if (isPreview) {
    var message =
      useContract.getContractFunctionPermission('Preview')?.disableMessage;
    if (message) {
      ElMessage({
        message,
        type: 'warning',
      });
      return;
    }
  }

  contractnet.DownloadPDF(draftId, isPreview).then((res) => {
    let blob = new Blob([res.data], {
      type: 'application/pdf;charset=utf-8',
    });
    let downloadElement = document.createElement('a');
    const href = window.URL.createObjectURL(blob);
    let contentDisposition = res.headers['content-disposition'];
    var patt = new RegExp('filename*=([^;]+\\.[^\\.;]+);*');
    var result = patt.exec(contentDisposition);
    var filename = decodeURI(result?.[1] || 'contract.pdf');
    downloadElement.style.display = 'none';
    downloadElement.href = href;
    downloadElement.download = filename;
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(href);
  });
};
//更改 Singn by
const changeSignByList = (index) => {
  const DraftInfo = ContractDrafts.value[index];
  DraftInfo.signByTitle = SignByList.value.find(
    (t) => t.signby_code == DraftInfo.signBy
  ).signby_title;
};

const ChangeClientAccountContact = (data, index) => {
  const dataInfo =
    useContractDraft.clientAccountContacList?.find(
      (t) => t.clientAccountContactNameEN === data
    ) || null;
  useContractDraft.ContractDrafts[index].clientAccountContactEmail =
    dataInfo?.clientAccountContactEmail || '';
  useContractDraft.ContractDrafts[index].clientAccountByTitle =
    dataInfo?.clientAccountByTitle || '';
  useContractDraft.ContractDrafts[index].clientAccountContactNameCN =
    dataInfo?.clientAccountContactNameCN || '';
  useContractDraft.ContractDrafts[index].clientAccountContactNumber =
    dataInfo?.clientAccountContactNumber || '';
};

// #endregion

// Disabled: 禁用开始日期日子
const DisabledDate = (val) => {
  return dateJs.DateDiff(new Date(), val) < 0;
};
// DateOfIssue: 禁用日期
const DisabledDate_DateOfIssue = (val) => {
  return (
    dateJs.DateDiff(ContractDrafts.value[0].dateOfIssueDisabledStart, val) >= 0
  );
};

const getPaymentTerm = (draftNo) => {
  var datas = ContractDraftPaymentDetails.value?.filter(
    (t) => t.contractDraftNo.indexOf(draftNo) >= 0
  ) || ['Payment Schedule'];

  if (datas) {
    const arr = datas.map((t) => t.psTypeLabel);

    var str = Array.from(new Set(arr)).join(';');
    return str;
  }
  return '';
};

const getPaymentSchedules = (draftNo) => {
  const datas =
    ContractDraftPaymentDetails.value?.filter(
      (t) => t.contractDraftNo.indexOf(draftNo) >= 0
    ) || [];

  var results = [];
  if (datas.length > 0) {
    for (let index = 0; index < datas.length; index++) {
      const element = datas[index];
      results.push(element);
    }
  }

  return results;
};
const isUrgent = () => {
  const useContractInfo = useContractInfoStore();
  const isUrgent = useContractInfo?.Contract?.isUrgent || false;
  return isUrgent;
};

const isPageLock = () => {
  var bPageLock =
    DraftContractPageStatus.value.filter((t) => t.isLock).length > 0;

  return bPageLock;
};

const PageUnlockClick = (index) => {
  var message =
    useContract.getContractFunctionPermission('PageUnlock')?.disableMessage;

  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  document.getElementById('toInternalRemark').scrollIntoView();
  DraftContractPageStatus.value[index].isUnlock = false;
  DraftContractPageStatus.value[index].isLock = true;

  const { disabled, isLock } = DraftContractPageStatus.value[index];
  changeDraftUpdate(ContractDrafts.value[index], disabled, isLock);
  //isPageUnlock.value = false;
};
const PageLockClick = async (index) => {
  var message =
    useContract.getContractFunctionPermission('PageUnlock')?.disableMessage;

  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }

  await SaveData(index, 'PageLock');

  // 更新页面状态
  DraftContractPageStatus.value[index].isUnlock = true;
  DraftContractPageStatus.value[index].isLock = false;

  DraftContractPageStatus.value.forEach((element, a) => {
    const { disabled, isLock } = DraftContractPageStatus.value[a];
    changeDraftUpdate(ContractDrafts.value[a], disabled, isLock);
  });

  //isPageUnlock.value = true;
};

const InternalRemarkDisabled = (index) => {
  if (DraftContractPageStatus.value[index].disabled && isLock(index)) {
    return false;
  }

  return DraftContractPageStatus.value[index].disabled;
};

const isUnlock = (index) => {
  return DraftContractPageStatus.value?.[index]?.isUnlock || false;
};

const isLock = (index) => {
  return DraftContractPageStatus.value?.[index]?.isLock || false;
};

const EditBilling = (index) => {
  var message =
    useContract.getContractFunctionPermission('EditBilling').disableMessage;
  if (message) {
    ElMessage({
      message,
      type: 'warning',
    });
    return;
  }
  ContractDrafts.value[index].clientAccountContact_Save = true;
};

const formatterMediaHeader = (data) => {
  const mediaJs = require('../js/Media.js');
  return mediaJs.unitGrossRate_str(JSON.parse(data)?.type);
};

defineExpose({
  getPageLock: () => {
    return isPageLock();
  },
});

const RawMediaDescriptionHTML = (id) => {
  var descriptions = [];
  var desc_str =
    ContractDraftMedias.value.find((t) => t.id == id)?.location || '';
  if (desc_str) {
    descriptions = JSON.parse(desc_str);
  }

  if (descriptions?.length > 0) {
    var html = '';
    descriptions.map((t) => {
      html += `<div style='${!html ? 'font-weight:bold' : ''}'>${t}</div>`;
    });
    return html;
  }
  return '';
};
// 上画日期HTML
const RawMediaVisualDateHTML = (dates) => {
  if (dates?.length > 0) {
    var html = '';
    dates.map((t) => {
      html += `<div>${t}</div>`;
    });
    return html;
  }
  return '';
};
</script>
<style scoped>
.input-control {
  padding-right: 20px;
}

.input-control-last {
  padding-right: 15px;
}

title {
  font-size: 13px;
}

.draftcontract .el-tabs__header {
  margin-bottom: 0;
}

.draftcontract .pane-body {
  padding: 20px 10px;
  background-color: var(--matrix-page-bg);
}

.nextbar .el-button,
.draftcontract .el-button:not(.el-button--text) {
  min-width: var(--matrix-button-min-width);
}

.el-button.pdf,
.el-button.pdf:focus,
.el-button.revised,
.el-button.revised:focus {
  background-color: #fd9727;
  border-color: #fd9727;
}

.el-button.pdf:hover,
.el-button.revised:hover {
  background-color: #fd9727;
  border-color: #fd9727;
  opacity: 0.7;
}

.el-button:disabled:not(.el-button--text),
.el-button:disabled:not(.el-button--text):hover {
  background-color: #999;
  border-color: #999;
}

.company,
.contactno {
  width: 82%;
  display: flex;
}

.company .entity,
.contactno .tel {
  width: 10%;
  margin-right: 2%;
}

.company .companyname,
.contactno .tel-input {
  width: 88%;
}

.formitem-control {
  display: flex;
}

.formitem-control .formitem-control-label {
  width: 30%;
}

.formitem-control .formitem-control-input {
  width: 70%;
}

.w-50p {
  width: 50%;
}

.sign-contract {
  height: 120px;
  width: 40%;
  border: 1px solid lightgray;
  margin-left: 20px;
  display: inline-block;
}
</style>
<style>
.spanText {
  width: 100px;
  text-align: right;
  margin-left: 10px;
  margin-right: 10px;
}

.is-not-shelter .el-tabs__header.is-top {
  display: none;
}

/* 用户对话框加大宽度 */
.is-message-box .draftconfirm {
  max-width: 523px;
}

.bonus-media .el-table__empty-block {
  min-height: 0px !important;
  height: 0px !important;
}

.btn.btn-pdf,
.btn.btn-pdf:hover,
.btn.btn-pdf:focus {
  width: 130px;
  background: linear-gradient(91deg, #eb6100 0%, #fe9350 100%) !important;
}

.date .el-input__inner {
  height: 36px !important;
}

.btn.btn-RegularSuccess,
.btn.btn-RegularSuccess:hover,
.btn.btn-RegularSuccess:focus,
.btn.btn-RegularSuccess:disabled .btn.active,
.btn.btn-RegularSuccess:not(:disabled):not(.disabled):active,
.btn.btn-RegularSuccess:not(:disabled):not(.disabled).active {
  background: #00bf9a !important;
}

#dateOfIssue,
#signBackBeforeDate {
  height: 3px !important;
}
</style>
